'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapCategoriesService = function () {
  function MapCategoriesService($http) {
    'ngInject';

    _classCallCheck(this, MapCategoriesService);

    this.$http = $http;
  }

  _createClass(MapCategoriesService, [{
    key: 'getProductQuery',
    value: function getProductQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'ProductName',
        direction: 'asc'
      });
    }
  }, {
    key: 'searchProducts',
    value: function searchProducts(query) {
      return this.$http.get('/odata/ProductCategoryMappingOData', {
        params: _extends({
          $select: 'ProductId, ProductCategoryId, ProductName, MapCount',
          $top: query.take,
          $skip: query.calculateSkip(),
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }, {
    key: 'addProductCategoryMapping',
    value: function addProductCategoryMapping(productCategoryId, productIds) {
      return this.$http.post('/api/product_category/' + productCategoryId + '/products', {
        productCategoryId: productCategoryId,
        productIds: productIds
      });
    }
  }, {
    key: 'removeProductCategoryMapping',
    value: function removeProductCategoryMapping(productCategoryId, productIds) {
      return this.$http.delete('/api/product_category/' + productCategoryId + '/products', {
        data: {
          productCategoryId: productCategoryId,
          productIds: productIds
        }
      });
    }
  }]);

  return MapCategoriesService;
}();

exports.default = MapCategoriesService;


// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.service.js